import { gql } from "generated-graphql";

gql(`
  fragment PortalFragment on Portal {
    id
    type
    jurisdiction
    portalTech
    url
    description
    capacity
    allowsMultiSessionLogin
    allowsCookieReuse
    requiresUsageOfChemicalDb
    usesMFA
    supportedProgramAreas
    isActive
    verifiable
    createdAt
    updatedAt
  }
`);

export const PORTAL_SEARCH = gql(`
  query PortalSearch($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    portalSearch(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        ...PortalFragment
      }
      count
    }
  }
`);

export const GET_PORTAL = gql(`
  query Portal($id: String!) {
    portal(id: $id) {
      ...PortalFragment
    }
  }
`);

export const UPSERT_PORTAL = gql(`
  mutation UpsertPortal($id: String, $input: PortalInput!) {
    upsertPortal(id: $id, input: $input) {
      ...PortalFragment
    }
  }
`);
